import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createBlock(_component_VueMultiselect, {
    options: _ctx.options,
    class: _normalizeClass([`${_ctx.getColoreStato(_ctx.modelValue)} next-vue-multiselect-stato`, _ctx.isOpen?'w-80' : '']),
    selectLabel: "",
    deselectGroupLabel: "",
    "track-by": "id",
    label: "descrizione",
    deselectLabel: "",
    selectGroupLabel: "",
    onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', $event))),
    onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = true)),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = false)),
    modelValue: _ctx.modelValue,
    disabled: !_ctx.options?.length
  }, {
    option: _withCtx(({option}) => [
      _createTextVNode(_toDisplayString(_ctx.getLabelStato(option)), 1)
    ]),
    singleLabel: _withCtx(({option}) => [
      _createTextVNode(_toDisplayString(_ctx.getLabelStato(option)), 1)
    ]),
    _: 1
  }, 8, ["options", "class", "modelValue", "disabled"]))
}